import { render, staticRenderFns } from "./PresenceList.vue?vue&type=template&id=0ba813f4&scoped=true&"
import script from "./PresenceList.vue?vue&type=script&lang=js&"
export * from "./PresenceList.vue?vue&type=script&lang=js&"
import style0 from "./PresenceList.vue?vue&type=style&index=0&id=0ba813f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba813f4",
  null
  
)

export default component.exports